const baseURL =
  window.location.origin === 'http://localhost:8080' ||
  window.location.origin === 'http://10.0.0.35:8080'
    ? 'http://127.0.0.1:8000/api'
    : 'https://api.geogridgame.com/api';

export default {
  baseURL: baseURL,
};
